<template>
  <div class="home" style="background: #F9FCFE">
    <div id="target"></div>
    <div class="main_top">
      <el-carousel
        :autoplay="true"
        trigger="click"
        height="660px"
        :interval="interval"
        @change="carChangeFn"
      >
        <el-carousel-item v-for="(item, index) in banList" :key="index">
          <img
            @click="handleGoToPage(item)"
            :src="item.img"
            alt=""
            class="banner_img"
          />
        </el-carousel-item>
      </el-carousel>
      <!-- <div class="total_data">
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="000"
              :end-value="235.99"
              :decimals="2"
              :options="countUpOp"
            ></v-countup>
            <span class="unit">万台套</span>
          </div>

          <div class="text">连接工业设备</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="0000"
              :end-value="2331"
              :options="countUpOp"
            ></v-countup>
            <span class="unit">个</span>
          </div>
          <div class="text">工业模型</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="0"
              :end-value="2754"
              :options="countUpOp"
            ></v-countup>
            <span class="unit">个</span>
          </div>

          <div class="text">工业APP</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="000000"
              :end-value="14259"
            ></v-countup>
            <span class="unit">家</span>
          </div>

          <div class="text">服务工业企业</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="0000"
              :end-value="5251"
              :options="countUpOp"
            ></v-countup>
            <span class="unit">个</span>
          </div>

          <div class="text">开发者注册数量</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="000"
              :end-value="572"
              :options="countUpOp"
            ></v-countup>
            <span class="unit">个</span>
          </div>

          <div class="text">活跃开发者数</div>
        </div>
      </div> -->
      <div class="total_dataBottom">
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="0"
              :end-value="17900"
              :options="countUpOp"
            ></v-countup>
            <!-- <span class="unit">次</span> -->
          </div>

          <div class="text">服务企业</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="000"
              :end-value="22"
              :options="countUpOp"
              :decimals="0"
            ></v-countup>
            <!-- <span class="unit">万元</span> -->
          </div>
          <div class="text">覆盖行业</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup class="num" start-value="0" :end-value="9"></v-countup>
            <!-- <span class="unit">个</span> -->
          </div>
          <div class="text">涉及领域</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="000"
              :end-value="2510955"
              :decimals="0"
              :options="countUpOp"
            ></v-countup>
            <!-- <span class="unit">个</span> -->
          </div>
          <div class="text">连接设备</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="0"
              :end-value="2358"
            ></v-countup>
            <!-- <span class="unit">个</span> -->
          </div>
          <div class="text">工业模型</div>
        </div>
        <div class="data_item">
          <div class="top">
            <v-countup
              class="num"
              start-value="0"
              :end-value="2810"
            ></v-countup>
            <!-- <span class="unit">个</span> -->
          </div>
          <div class="text">工业APP</div>
        </div>
      </div>
    </div>
    <div class="main_two">
      <div class="title">天信工业互联网平台</div>
      <div class="content_text">
        “天信工业互联网平台”连续三年（2022-2024）获选工信部跨行业跨领域工业互联网平台，这是河南省获选的唯一一家国家级“双跨”平台。
      </div>
      <div class="content_text">
        平台通过构建全要素连接底座和工业数据智能引擎，为制造业企业提供覆盖研发、生产、供应链、服务全链条的数字化服务。
      </div>
      <div class="content_text">
        平台深度赋能装备制造、能源化工、电子信息等多个行业,助力企业降本增效、创新模式，驱动千行百业数字化转型。​
      </div>

      <img
        src="../../../assets/image/home/model.png"
        alt=""
        style="width: 100%"
      />
    </div>
    <div class="main_product">
      <div class="button_list">
        <div class="main_title">安全稳定便捷的产品及服务</div>
        <div class="btn_item">
          <!-- 查看更多&nbsp;

          <img
            src="../../../assets/image/home/arrow.png"
            alt=""
            style="width: 14px"
          /> -->
        </div>
      </div>
      <el-carousel style="width: 100%; padding-bottom: 100px" arrow="always">
        <el-carousel-item
          v-for="(item, index) in 2"
          :key="item"
          indicator-position="outside"
        >
          <div class="container">
            <div
              class="item"
              v-for="(ele, i) in productList[index]"
              :key="i"
              @click="handletoProductDetail(ele.id)"
            >
              <div class="title">
                {{ ele.name
                }}<span class="tips" v-if="i < 3 && index == 0">力荐</span>
              </div>
              <div class="content">
                {{ ele.info }}
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="main_scheme">
      <div class="button_list">
        <div class="main_title">多行业多领域解决方案</div>
        <div class="btn_item">
          <!-- 查看更多&nbsp;
          <img
            src="../../../assets/image/home/arrow.png"
            alt=""
            style="width: 14px"
          /> -->
        </div>
      </div>
      <el-tabs
        v-model="schemeName"
        style="width: 60%"
        stretch
        @tab-click="handleClickSchemeName"
      >
        <el-tab-pane
          :label="ele.name"
          :name="ele.id"
          :key="ele.id"
          v-for="(ele, i) in schemeList"
        ></el-tab-pane>
      </el-tabs>
      <div class="wrapper">
        <div class="left">
          <div class="name">{{ currentScheme.name }}</div>
          <div class="en">{{ currentScheme.en }}</div>
          <div class="desc">
            {{ currentScheme.desc }}
          </div>
          <div class="tags">
            <div class="item" v-for="ele in currentScheme.product" :key="ele">
              {{ ele }}
            </div>
          </div>
          <div class="more_btn">更多</div>
        </div>
        <div class="right">
          <img
            v-if="currentScheme.id == 1"
            src="../../../assets/image/home/01建材行业.jpg"
            alt=""
          />
          <img
            v-else-if="currentScheme.id == 2"
            src="../../../assets/image/home/02非煤露天矿行业.jpg"
            alt=""
          />
          <img
            v-else-if="currentScheme.id == 3"
            src="../../../assets/image/home/03黑色金属制造业.jpg"
            alt=""
          />
          <img
            v-else-if="currentScheme.id == 4"
            src="../../../assets/image/home/04设备领域.jpg"
            alt=""
          />
          <img
            v-else-if="currentScheme.id == 5"
            src="../../../assets/image/home/05物流领域.jpg"
            alt=""
          />
          <img
            v-else-if="currentScheme.id == 6"
            src="../../../assets/image/home/06供应链领域.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="main_case">
      <div class="button_list">
        <div class="main_title">成功案例</div>
        <div class="btn_item">
          <!-- 查看更多&nbsp;
          <img
            src="../../../assets/image/home/arrow.png"
            alt=""
            style="width: 14px"
          /> -->
        </div>
      </div>
      <el-tabs v-model="caseName" style="width: 50%" stretch>
        <el-tab-pane
          :label="ele.name"
          :name="ele.id"
          :key="ele.id"
          v-for="(ele, i) in caseList"
        ></el-tab-pane>
      </el-tabs>

      <div class="wrapper" v-if="caseName == 1">
        <div class="left">
          <img src="../../../assets/image/home/01智慧园区.jpg" alt="" />
        </div>
        <div class="right">
          <div class="title">
            <div class="name">智慧园区</div>
            <div class="more" @click="handletoDetail('1611273162910654465')">
              &nbsp;
              <img
                src="../../../assets/image/home/arrow.png"
                alt=""
                style="width: 14px"
              />&nbsp; 详情&nbsp;
            </div>
          </div>
          <div class="list">
            <div class="left-title">客户需求</div>
            <div class="right-content">
              园区管控和隐患治理需求，对园区企业的环保监测需求，园区车辆管理需求等等。
            </div>
          </div>
          <div class="list">
            <div class="left-title">赋能方案</div>
            <div class="right-content">
              针对环保监测对象进行详细监测，督促企业完成环保任务。对园区及企业安全生产状况进行分析预警，提高监管工作的实效和水平。实现对重点能耗对象能源利用状况进行实时、准确的动态监管。
              对进入园区的车辆进行智能化管理，提高进出厂效率，识别排放标准。
            </div>
          </div>
          <div class="list">
            <div class="left-title">相关方案</div>
            <div class="right-content">
              <div class="tags">
                <div class="item">智慧园区</div>
                <div class="item">工业互联网园区解决方案</div>
              </div>
            </div>
          </div>

          <div class="data">
            <div class="container">
              <div>
                <div class="child">
                  <div class="num">60%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">安全监管效率提升</div>
              </div>

              <div>
                <div class="child">
                  <div class="num">98%</div>
                  <sub style="line-height: 92px">
                    <img alt="" />
                  </sub>
                </div>
                <div style="margin-top: -28px">AI预警准确率达到</div>
              </div>
              <div>
                <div class="child">
                  <div class="num">50%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">车辆进入场效率提升</div>
              </div>
              <div>
                <div class="child">
                  <div class="num">20%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/downarrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">降低企业能耗</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-else-if="caseName == 2">
        <div class="left">
          <img src="../../../assets/image/home/02智慧矿山.jpg" alt="" />
        </div>
        <div class="right">
          <div class="title">
            <div class="name">智慧矿山</div>
            <div class="more" @click="handletoDetail('1610912053154344961')">
              &nbsp;
              <img
                src="../../../assets/image/home/arrow.png"
                alt=""
                style="width: 14px"
              />&nbsp; 详情&nbsp;
            </div>
          </div>
          <div class="list">
            <div class="left-title">客户需求</div>
            <div class="right-content">
              储量信息实时显示和预警；开采/爆破作业有计划，可追溯；任务调度和配矿的智能化；矿山生产安全的智能监管；生产运输作业的少人化和无人化；
            </div>
          </div>
          <div class="list">
            <div class="left-title">赋能方案</div>
            <div class="right-content">
              根据露天非金属矿山企业的实际管控需求，结合行业痛点，通过信息化、数字化、智能化手段，对矿山生产计划、钻孔、爆破、质检、铲、装、运、计量等各项工作或环节进行管理，全流程收集生产数据，允许对各环节进行追溯、分析，解决了传统矿山系统不互通，数据不互通，业务不互通的问题。
            </div>
          </div>
          <div class="list">
            <div class="left-title">相关方案</div>
            <div class="right-content">
              <div class="tags">
                <div class="item">能碳管家</div>
                <div class="item">设备预测性维护平台</div>
                <div class="item">水泥行业智能化节能降碳解决方案</div>
                <div class="item">水泥行业设备远程运维解决方案</div>
              </div>
            </div>
          </div>

          <div class="data">
            <div class="container">
              <div>
                <div class="child">
                  <div class="num">30%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">资源综合利用率提升</div>
              </div>

              <div>
                <div class="child">
                  <div class="num">5%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">产能提升</div>
              </div>
              <div>
                <div class="child">
                  <div class="num">1.5%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/downarrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">电耗降低</div>
              </div>
              <div>
                <div class="child">
                  <div class="num">10%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">作业效率提升</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-else-if="caseName == 3">
        <div class="left">
          <img src="../../../assets/image/home/03生产智能控制.jpg" alt="" />
        </div>
        <div class="right">
          <div class="title">
            <div class="name">生产智能控制</div>
            <div class="more" @click="handletoDetail('1610151890856267778')">
              &nbsp;
              <img
                src="../../../assets/image/home/arrow.png"
                alt=""
                style="width: 14px"
              />&nbsp; 详情&nbsp;
            </div>
          </div>
          <div class="list">
            <div class="left-title">客户需求</div>
            <div class="right-content">
              节能降耗需求，需要不断优化工艺和操作方式，降低生产能耗水平，节能减排，降低成本。人才紧缺，人才培养周期长的问题，迫切需要提升生产过程智能化水平需求。
            </div>
          </div>
          <div class="list">
            <div class="left-title">赋能方案</div>
            <div class="right-content">
              通过烧成系统智能引擎，实现降低分解炉温度、窑头负压和篦冷机篦压等变量波动，稳定熟料游离氧化钙的波动，合理控制系统氧含量，降低单位熟料的煤耗和电耗。
              通过水泥磨智能控制引擎，实现磨机出口颗粒度的稳定，在满足颗粒度要求、磨机电流和压差等条件下实现产能最大化，稳定成品质量，减少熟料的掺量，降低水泥电耗。
            </div>
          </div>
          <div class="list">
            <div class="left-title">相关方案</div>
            <div class="right-content">
              <div class="tags">
                <div class="item">水泥生产APC</div>
                <div class="item">“两磨一窑”优化控制解决方案</div>
              </div>
            </div>
          </div>

          <div class="data">
            <div class="container">
              <div>
                <div class="child">
                  <div class="num">15%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">熟料强度提高</div>
              </div>

              <div>
                <div class="child">
                  <div class="num">1.9%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/downarrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">生产煤耗降低</div>
              </div>

              <div>
                <div class="child">
                  <div class="num">1.5%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/downarrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">生产电耗降低</div>
              </div>
              <div>
                <div class="child">
                  <div class="num">23%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/downarrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">关键变量波动降低</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-else-if="caseName == 4">
        <div class="left">
          <img src="../../../assets/image/home/04智慧物流.jpg" alt="" />
        </div>
        <div class="right">
          <div class="title">
            <div class="name">智能物流</div>
            <div class="more" @click="handletoDetail('1610573896357572609')">
              &nbsp;
              <img
                src="../../../assets/image/home/arrow.png"
                alt=""
                style="width: 14px"
              />&nbsp; 详情&nbsp;
            </div>
          </div>
          <div class="list">
            <div class="left-title">客户需求</div>
            <div class="right-content">
              各系统间无法做到数据互通；岗位人员重复录入数据、错误率高；车辆重量作弊，压磅、不完全上磅，给企业成本带来巨大的损失。
              人力成本巨大需要优化，作业效率需要提交。
            </div>
          </div>
          <div class="list">
            <div class="left-title">赋能方案</div>
            <div class="right-content">
              通过融合物联网、AI
              识别、自动化控制、云计算等技术，实现地磅称重全流程的自动化、智能化和数据化管理。该系统能够大幅减少人工干预，提高效率、准确性和透明度，并有效堵塞管理漏洞，全面提升企业发运效率，杜绝作弊行为。
            </div>
          </div>
          <div class="list">
            <div class="left-title">相关方案</div>
            <div class="right-content">
              <div class="tags">
                <div class="item">无人值守</div>
                <div class="item">智能计量一体化解决方案</div>
              </div>
            </div>
          </div>

          <div class="data">
            <div class="container">
              <div>
                <div class="child">
                  <div class="num">90%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">计量效率提升</div>
              </div>

              <div>
                <div class="child">
                  <div class="num">100%</div>
                  <sub style="line-height: 92px"><img alt="" /></sub>
                </div>
                <div style="margin-top: -28px">化计量过程人员</div>
              </div>
              <div>
                <div class="child">
                  <div class="num">150%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">进出厂效率提升</div>
              </div>
              <div>
                <div class="child">
                  <div class="num">100%</div>
                  <sub style="line-height: 92px"
                    ><img src="../../../assets/image/home/uparrow.png" alt=""
                  /></sub>
                </div>
                <div style="margin-top: -28px">杜绝作弊行为提升</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main_four">
      <div class="title">公司及行业新闻</div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in newTabList"
          :key="index"
          :label="item.name"
          :name="item.id"
          class="main_four_cont"
        >
          <home-news-list :news="ex.news" :list="ex.list"> </home-news-list>
        </el-tab-pane>
      </el-tabs>
    </div>
    <left-float-btn currentPage="home"></left-float-btn>
  </div>
</template>
<script>
// @ is an alias to /src
import banner2 from "../../../assets/video/banner2.png";
import banner3 from "../../../assets/video/banner3.png";
import banner4 from "../../../assets/image/contentUs_bg.png";
import news from "../../../assets/image/home/news.png";
import HomeNewsList from "@components/HomeNewsList";
import LeftFloatBtn from "../../../components/LeftFloatBtn";
import Bus from "@/config/bus";
export default {
  name: "Home",
  components: { LeftFloatBtn, HomeNewsList },
  data() {
    return {
      countUpOp: {
        // suffix: "+", // 后缀
      },
      showLock: null,
      newsList: {
        news: {},
        list: [],
      },

      stateList: {
        news: {},
        list: [],
      },

      policyList: {
        news: {},
        list: [],
      },
      ex: {
        news: {},
        list: [],
      },
      activeName: "first",
      schemeName: "1",
      caseName: "1",
      threeActive: 1,
      banList: [],
      newTabList: [],
      details: {
        title: "标题",
        author: "名字",
        date: "2022-03-20",
        skim: 200,
        subtitle: "副标题",
        section: "文章内容",
      },
      carIndex: 0,
      interval: 3000,
      productList: [
        [
          {
            name: "天策大数据",
            info: "为企业提供数字化构建能力和一致性的使用体验。",
            id: "1620368556852584449",
          },
          {
            name: "天脉物联网",
            info: "提供开箱即用的物联网云或本地解决方案。",
            id: "1613031555463737346",
          },
          {
            name: "能碳管家",
            info: "实现整体矿山生产作业流程闭环管理。",
            id: "1613785000894283778",
          },
          {
            name: "智慧矿山",
            info: "实现业务集成管理，降本增效、服务客商，提升企业核心竞争力。",
            id: "1613798999237083138",
          },
          {
            name: "无人值守",
            info: "实现业务集成管理，降本增效、服务客商，提升企业核心竞争力。",
            // id: "1613798999237083138",
          },
          {
            name: "设备预测性维护平台",
            info: "支撑企业从事后维修到预测性维修转型。",
            id: "1608385875398959106",
          },
          {
            name: "水泥行业生产先进控制系统",
            info: "帮助企业节能减排，降低成本。",
            id: "1614166336922468353",
          },
          {
            name: "水泥制造运营管理系统",
            info: "提供系统的操作指导、生产过程运行指标、经济指标和决策依据。",
            id: "1614155649789739010",
          },
          {
            name: "双预防系统  ",
            info: "为企业安全生产、政府有效监管和第三方信息共享保驾护航。",
            //  id:'1614155649789739010'
          },
          {
            name: "安环管理系统",
            info: "为安全生产、安全防控、监测预警、应急救援等工作提供智能化的手段。",
            //  id:'1614155649789739010'
          },
        ],
        [
          {
            name: "供应链协同平台",
            info: "打破供应链各环节之间的信息壁垒，建立高效的协同机制，提升效率。",
            id: "1608348967591550978",
          },
          {
            name: "车辆流向管控平台",
            info: "为企业提供在途车辆流向管控服务，实现对货物流向的精细化管控。",
            id: "1644157304495443969",
          },
          {
            name: "可再生资源贸易平台",
            info: "实现资源供应信息与需求信息的集中展示与精准匹配。",
            id: "1644147304897310721",
          },
          {
            name: "天信低代码平台",
            info: "助力企业实现应用快速构建和各种场景化连接。",
            id: "1644221691558137858",
          },
        ],
        [],
      ],
      schemeList: [
        {
          id: "1",
          name: "建材行业",
          en: "Building materials industry",
          desc: "为水泥企业提供生产经营、节能降碳、设备远程管理、智慧物流等多种数字化产品及解决方案。",
          product: [
            "天脉物联网",
            "设备预测性维护平台",
            "无人值守",
            "水泥制造运营管理系统",
          ],
          pic: "../../../assets/image/home/kuangshan.png",
        },
        {
          id: "2",
          name: "非煤露天矿行业",
          en: "Non coal open-pit mining industry",
          desc: "解决露天非金属矿山企业开采成本高、安全监管难、品位搭配难、招工难等问题。",
          product: ["智慧矿山", "天脉物联网", "无人值守", "安全管理系统"],
          pic: "../../../assets/image/home/kuangshan.png",
        },
        {
          id: "3",
          name: "黑色金属制造业",
          en: "Black metal manufacturing industry",
          desc: "解决黑色金属制造业产成品过程质量控制难、产品流转易出错、溯源周期长等问题。",
          product: [
            "条码管理系统",
            "供应链协同平台",
            "无人值守",
            "设备诊断平台",
          ],
        },
        {
          id: "4",
          name: "设备领域",
          en: "Equipment field",
          desc: "解决设备现场巡检周期长、现场作业难度大、设备维修状况复杂等问题，可适用于水泥、电力、钢铁、石化、有色金属等9个行业",
          product: ["设备预测性维护平台", "天脉物联网", "天策大数据"],
        },
        {
          id: "5",
          name: "物流领域",
          en: "Logistics field",
          desc: "解决生产制造型企业运输环节找车难、运输成本高、运输过程监管难等问题，可适用于钢铁、水泥、电力、化工、能源、煤炭、造纸、化肥等多个行业",
          product: [
            "智慧物流平台",
            "车辆流向管控服务平台",
            "智能计量无人值守系统",
          ],
        },
        {
          id: "6",
          name: "供应链领域",
          en: "Supply chain field",
          desc: "解决生产制造型企业采购过程管控难、库存成本高、销售订单与生产无法联动、计量监管难等问题产销协同一体化解决方案",
          product: ["供应链协同平台", "智能计量", "智能计量无人值守系统"],
        },
      ],
      caseList: [
        { id: "1", name: "智慧园区" },
        { id: "2", name: "智慧矿山" },
        { id: "3", name: "生产智能控制" },
        { id: "4", name: "智慧物流" },
      ],
      currentScheme: {
        id: "1",
        name: "建材行业",
        en: "Building materials industry",
        desc: "为水泥企业提供生产经营、节能降碳、设备远程管理、智慧物流等多种数字化产品及解决方案。",
        product: [
          "天脉物联网",
          "设备预测性维护平台",
          "无人值守",
          "水泥制造运营管理系统",
        ],
        pic: require("../../../assets/image/home/kuangshan.png"),
      },
    };
  },
  watch: {
    $route() {
      let v = document.getElementById("video1");
      if (v) {
        v.play();
      }
    },
    carIndex(n, o) {
      if (!n) {
        this.interval = 3000;
      } else {
        this.interval = 3000;
      }
    },
  },
  methods: {
    handleGoToPage(item) {
      if (item.url) {
        window.location.href = item.url;
      } else {
        return;
      }
    },
    async getChannelNews(id) {
      let res = await this.API.home.getChannelNews({
        channelId: id,
      });
      if (res.code == 200) {
        this.ex.news = res.data.length > 0 ? res.data[0] : {};
        this.ex.list = res.data.length > 0 ? res.data.splice(1, 10) : [];
      }
    },
    async getBanner() {
      let res = await this.API.home.getBanner();
      if (res.code == 200) {
        this.banList = res.data.records.splice(0, 6);
      }
    },
    async getChannels() {
      let res = await this.API.home.getChannels();
      if (res.code == 200) {
        this.newTabList = res.data;
        this.activeName = res.data[0].id;
        this.getChannelNews(this.activeName);
      }
    },
    goToDeatilFn() {
      this.$router.push({
        path: "/OnlineMsg",
      });
    },
    carChangeFn(index) {
      this.carIndex = index;
    },

    handleClick(tab, event) {
      console.log(tab, event);
      this.getChannelNews(this.activeName);
    },
    handleChangeThree(val) {
      this.threeActive = val;
    },
    async getMainMenu() {
      let res = await this.API.home.getMainMenu();
      if (res.code == 200) {
        // this.productList[0] = res.data.productList.slice(0, 6);
        // this.productList[1] = res.data.productList.slice(6, 12);
        // this.productList[2] = res.data.productList.slice(12);
        // this.schemeList = res.data.schemeList;
        // this.schemeName = res.data.schemeList[0].id;
        // this.currentScheme = res.data.schemeList[0];
        // console.log(this.productList);
      }
    },
    handleClickSchemeName(tab) {
      this.currentScheme = this.schemeList.find((ele) => ele.id == tab.name);
      console.log(this.currentScheme, "this.currentScheme");
    },
    onClickMore() {
      // this.$nextTick(() => {
      //   window.scrollTo({
      //     top: 1600, //2075/2757
      //     left: 0,
      //     behavior: "smooth",
      //   });
      // });
      // setTimeout(() => {
      //   Bus.$emit("updateFileList", data, 1);
      // });
    },

    moveMouseTo(x, y) {
      console.log(x, y, "x, yx, yx, yx, yx, y");
      this.$nextTick(() => {
        // 创建一个鼠标移动事件
        var mouseEvent = new MouseEvent("mousemove", {
          screenX: x,
          screenY: y,
          clientX: x,
          clientY: y,
          bubbles: true,
        });

        // 触发事件，模拟鼠标移动
        document.body.dispatchEvent(mouseEvent);
      });
    },

    handletoDetail(id) {
      window.location.href = `/product.html#/caseDetail?id=${id}`;
    },
    handletoProductDetail(id) {
      window.location.href = `/product.html#/detail?id=${id}`;
    },
  },

  mounted() {
    this.getBanner();
    this.getChannels();
    this.getMainMenu();
    // document.addEventListener("scroll", function () {
    //   // 滑动事件的处理逻辑
    //   if(document.documentElement.scrollTop>1300&&document.documentElement.scrollTop<1600){
    //     window.scrollTo({
    //       top: 1600,
    //       left: 0,
    //       behavior: "smooth",
    //     });
    //   }
    // });
  },
};
</script>
<style lang="scss" scoped>
/deep/ .main_top .el-carousel__button {
  width: 10px;
  height: 10px;
  opacity: 1;
  border-radius: 90px;
}

/deep/ .main_top .el-carousel__indicator.is-active button {
  width: 10px !important;
  height: 10px;
  background: #00d8ff !important;
  opacity: 1;
  border-radius: 90px;
}
::v-deep .main_top .el-carousel__arrow {
  background-color: #271e5e;
}
::v-deep .main_top .el-carousel__arrow i {
  color: #fff !important;
}

/deep/ .main_product .el-carousel__button {
  width: 32px !important;
  height: 6px;
  background: #d8d8d8;
  // opacity: 1;
  // border-radius: 90px;
}
/deep/ .main_product .el-carousel__indicator.is-active button {
  width: 32px !important;
  height: 6px;
  opacity: 1;
  background: #1e4da5;
}
/deep/ .main_product .el-carousel__arrow {
  background: transparent;
  // opacity: 1;
  // border-radius: 90px;
  color: #335eae;
}
/deep/ .main_product .el-carousel__arrow i {
  font-size: 28px;
  // opacity: 1;
  // border-radius: 90px;
  color: #2a6aca !important;
}
/deep/ .main_product .el-carousel__item[data-v-60b36c83]:nth-child(2n + 1) {
  background: transparent !important;
}
/deep/ .main_product .el-carousel__item[data-v-60b36c83]:nth-child(2n) {
  background: transparent !important;
}
/deep/ .main_product .el-carousel__item[data-v-60b36c83]:nth-child(2n) {
  background: transparent !important;
}

.main_top {
  width: 100%;
  // height: 660px;
  position: relative;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }

.banner_item {
  /*position: relative;*/
  .item_text {
    position: absolute;
    top: 257px;
    color: white;
    right: 120px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;

    .banner_eng {
      width: 565px;
      height: 35px;
    }

    .banner_zh {
      width: 507px;
      height: 48px;
    }

    .line {
      width: 68px;
      height: 8px;
      background: #ffffff;
      opacity: 1;
      border-radius: 0px;
    }

    .btn_banner {
      position: relative;
      z-index: 22;
      margin-top: 120px;
      display: flex;
      justify-content: flex-end;

      .buy {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 140px;
        height: 40px;
        background: #0066ff;
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }

      .other {
        margin-left: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 140px;
        height: 40px;
        background: #31b2f5;
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
    }

    .subTitle {
      margin-top: 23px;
      width: 398px;
      height: 38px;
      background: linear-gradient(
        90deg,
        rgba(95, 170, 236, 0.55) 0%,
        rgba(96, 170, 236, 0.31) 26%,
        rgba(101, 172, 236, 0.29) 48%,
        rgba(97, 170, 236, 0.4) 74%,
        rgba(95, 170, 236, 0.54) 100%
      );
      opacity: 1;
      border-radius: 0px;
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      font-family: PingFang SC;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.banner_img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

/deep/ .main_top .el-carousel__indicators {
  // 指示器
  /*left: 154px;*/
  // bottom: 108px;
  // right: unset;
}

/deep/ .main_top .el-carousel__button {
  // width: 8px;
  // height: 8px;
  // opacity: 1;
  // border-radius: 90px;
}

.main_top .el-carousel__indicator.is-active button {
  // width: 36px !important;
  // height: 8px;
  background: #2a6aca;
  // opacity: 1;
  // border-radius: 90px;
}

.total_data {
  width: 85%;
  min-width: 1150px;
  margin: 0 auto;
  height: 148px;
  background: white;
  margin-top: -74px;
  box-shadow: 0px 2px 12px rgba(63, 104, 158, 0.19);
  opacity: 1;
  border-radius: 6px;
  z-index: 666;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 68px;

  .data_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 300px;
    min-width: 180px;
    .top {
      display: flex;
      align-items: center;
      .num {
        font-size: 28px;
        font-family: Bahnschrift;
        font-weight: 400;
        color: #495770;
        opacity: 1;
      }
      .unit {
        font-size: 14px;
        font-family: Microsoft YaHei;
        color: #495770;
        margin: 2px 0 0 6px;
      }
    }
    .num {
      font-size: 28px;
      font-family: Bahnschrift;
      font-weight: 400;
      color: #495770;
      opacity: 1;
    }
    .text {
      margin-top: 12px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #97a2b0;
      opacity: 1;
    }
  }
}
.total_dataBottom {
  // width: 85%;
  background-color: #F9FCFE;
  min-width: 1150px;
  margin: 0 auto;
  height: 148px;
  // background: white;
  margin-top: 50px;
  opacity: 1;
  // border-radius: 6px;
  z-index: 666;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 68px 0 68px;
  // box-shadow: 0px 5px 5px 0 rgba(63, 104, 158, 0.19);
  .data_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 300px;
    min-width: 180px;
    .top {
      display: flex;
      align-items: center;
      .num {
        font-size: 32px;
        font-family: Bahnschrift;
        font-weight: 400;
        color: #495770;
        opacity: 1;
      }
      .unit {
        font-size: 14px;
        font-family: Microsoft YaHei;
        color: #495770;
        margin: 2px 0 0 6px;
      }
    }
    .num {
      font-size: 32px;
      font-family: Bahnschrift;
      font-weight: 400;
      color: #495770;
      opacity: 1;
    }
    .text {
      margin-top: 12px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #495770;
      opacity: 1;
    }
  }
}
.main_two {
  /*background: url("../../../assets/image/home/bg_home2.png");*/
  /*background-size: 100% 100%;*/
  width: 100%;
  // height: 1200px;
  background-color: #F9FCFE;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
  .title {
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #16181a;
    opacity: 1;
    margin-bottom: 30px;
    font-weight: 700;
    font-size: 36px;
    text-align: left;
    color: #000000 100%;
  }

  .content_text {
    width: 1100px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #474748;
    opacity: 1;
    text-align: center;
  }

  .content-img-text {
    width: 1200px;
    display: flex;
    background: #fff;
    box-shadow: 0 2px 12px rgba(63, 104, 158, 0.19);
    margin-top: 60px;

    img {
      width: 700px;
      height: 280px;
      margin-right: 46px;
    }

    .item-title {
      font-family: "Microsoft YaHei Bold";
      font-weight: 700;
      font-size: 20px;
      text-align: left;
      color: #1d2129;
      margin-top: 44px;
      z-index: 6;
      position: relative;
    }

    .eng-text {
      font-family: "Microsoft YaHei Bold";
      font-weight: 700;
      font-size: 24px;
      text-align: left;
      color: #ededee;
      margin-top: -12px;
      z-index: 2;
      position: relative;
    }

    .item-text {
      margin-top: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 14px;
      line-height: 32px;
      text-align: left;
      color: #1d2129;
      width: 414px;
    }
  }
}

.main_three {
  background: url("../../../assets/image/home/bg_home2.png");
  background-size: 100% 100%;
  box-shadow: 0px 3px 16px rgba(27, 36, 90, 0.16);
  margin-top: 16px;
  padding: 53px 194px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .three_img {
    width: 1048px;
    height: 703px;
    margin: 10px auto;
  }

  .button_list {
    margin-bottom: 20px;
    .btn_item {
      margin: 0 14px;
      width: 100%;
      height: 60px;
      border-radius: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 28px;
      color: #1d2129;
      text-align: center;
    }

    .main-subtitle {
      color: #495770;
      font-size: 20px;
      font-weight: bold;
      height: 60px;
      line-height: 60px;
    }
  }
}

.main_product {
  background: url("../../../assets/image/home/bg_home3.png");
  background-size: 100% 100%;
  // box-shadow: 0px 3px 16px rgba(27, 36, 90, 0.16);
  // padding: 53px 53px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  padding-top: 57px;
  .container {
    margin: 0 100px;
    padding: 0 100px;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 100%;
    background: #ffffff;
    gap: 5%;
    .item {
      width: 13.5%;
      display: flex;
      flex-direction: column;
      padding-top: 30px;
      cursor: pointer;
      // align-content: center;
      // justify-content: center;

      .title {
        font-weight: 700;
        font-size: 16px;
        text-align: left;
        color: #333333 100%;
        display: flex;
        justify-content: space-between;
      }
      .tips {
        background: red;
        color: #ffffff;
        font-size: 12px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 0 1px;
      }

      .content {
        margin-top: 24px;
        font-size: 14px;
        text-align: left;
        color: #797a7a;
        line-height: 1.4;
      }
    }
  }
  .three_img {
    width: 1048px;
    height: 703px;
    margin: 10px auto;
  }

  .button_list {
    .main_title {
      margin: 0 14px;
      width: 100%;
      border-radius: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Microsoft YaHei";
      font-weight: 700;
      font-size: 28px;
      color: #1d2129;
      text-align: center;
      margin-bottom: 20px;
    }
    .btn_item {
      margin: 20px 0;
      border-radius: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 14px;
      color: #1d2129;
      text-align: center;
      cursor: pointer;
      color: #0066ff;
    }

    .main-subtitle {
      color: #495770;
      font-size: 20px;
      font-weight: bold;
      height: 60px;
      line-height: 60px;
    }
  }
}
.main_scheme {
  // background: url("../../../assets/image/home/bg_home2.png");
  background-size: 100% 100%;

  // box-shadow: 0px 3px 16px rgba(27, 36, 90, 0.16);
  padding: 53px 0px;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  .wrapper {
    display: flex;
    width: 100%;
    padding-left: 18%;
    margin-top: 22px;
    .left {
      width: 39.5%;

      font-weight: 400;
      color: #606060;
      line-height: 1.5;
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-right: 50px;
      .name {
        font-size: 26px;
        font-weight: 700;
        text-align: left;
        color: #1e4da5;
        letter-spacing: 8px;
      }
      .en {
        color: #959595;
        font-size: 26px;
        font-weight: 700;
      }
      .desc {
        color: #606060;
        margin-top: 12px;
        font-size: 16px;
      }
      .tags {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        width: 300px;
        margin-top: 36px;
        font-size: 15px;
        padding: auto 6px;
        .item {
          background: #1e4da5;
          padding: 5px 10px;
          color: #fff;
        }
      }
      .more_btn {
        border: 0.5px solid #dbdbdb;
        padding: 6px 20px;
        display: inline-block;
        margin-top: 12px;
        cursor: pointer;
        width: 76px;
      }
    }
    .right {
      flex: 1;
      img {
        width: 100%;
      }
    }
  }
  .container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 12px;

    .item {
      width: 20%;
    }
  }
  .three_img {
    width: 1048px;
    height: 703px;
    margin: 10px auto;
  }

  .button_list {
    .main_title {
      margin: 0 14px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Microsoft YaHei";
      font-weight: 700;
      font-size: 28px;
      color: #1d2129;
      text-align: center;
      margin-bottom: 20px;
    }
    .btn_item {
      margin: 20px 0;
      border-radius: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 14px;
      color: #1d2129;
      text-align: center;
      cursor: pointer;
      color: #0066ff;
    }

    .main-subtitle {
      color: #495770;
      font-size: 20px;
      font-weight: bold;
      height: 60px;
      line-height: 60px;
    }
  }
}
.main_case {
  background-size: 100% 100%;
  // box-shadow: 0px 3px 16px rgba(27, 36, 90, 0.16);
  padding: 53px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;

  .wrapper {
    display: flex;
    margin-top: 12px;
    width: 100%;
    .left {
      flex: 1;
      img {
        width: 100%;
      }
    }
    .right {
      width: 50%;
      font-size: 33px;
      font-weight: 400;
      color: #606060 100%;
      line-height: 2;
      padding: 0 5%;
      background: #f0f7fe;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .list {
        display: flex;
        margin-top: 12px;
        .left-title {
          font-weight: 700;
          min-width: 100px;
          height: 28px;
          font-size: 14px;
          text-align: left;
          color: #2250a7;
        }
        .right-content {
          display: flex;
          flex-wrap: wrap;
          color: #6d6d6d;
          font-family: "Microsoft YaHei", Arial, sans-serif;
          font-size: 14px;
        }
      }

      .title {
        display: flex;
        align-items: center;
        .name {
          font-weight: 700;
          font-size: 27px;
          text-align: left;
          color: #204fa6;
          letter-spacing: 4px;
        }
        .more {
          cursor: pointer;
          color: #204fa6;
          margin-top: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .tags {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        .item {
          background: #1e4da5;
          padding: 5px 10px;
          color: #fff;
        }
      }
      .container {
        display: flex;
        .child {
          display: flex;
          .num {
            font-weight: 700;
            font-size: 42px;
            text-align: left;
            color: #3b3b3b 100%;
          }
          img {
            width: 12px;
          }
        }
      }
    }
  }
  .container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 12px;

    .item {
      width: 20%;
    }
  }
  .three_img {
    width: 1048px;
    height: 703px;
    margin: 10px auto;
  }

  .button_list {
    .main_title {
      width: 100%;
      border-radius: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Microsoft YaHei";
      font-weight: 700;
      font-size: 28px;
      color: #1d2129;
      text-align: center;
      margin-bottom: 20px;
    }
    .btn_item {
      margin: 20px 0;
      border-radius: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 14px;
      color: #1d2129;
      text-align: center;
      cursor: pointer;
      color: #0066ff;
    }

    .main-subtitle {
      color: #495770;
      font-size: 20px;
      font-weight: bold;
      height: 60px;
      line-height: 60px;
    }
  }
}
.main_four {
  width: 100%;
  padding: 62px 20px;

  /deep/ .el-tabs__nav-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/.is-scrollable {
    .el-tabs__nav-scroll {
      justify-content: flex-start !important;
    }
  }
  .title {
    text-align: center;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    color: #16181a;
    opacity: 1;
    margin-bottom: 60px;
  }

  .main_four_cont {
    padding-top: 24px;
    padding-bottom: 24px;
    display: flex;

    .main_four_left {
      width: 490px;
    }
  }
}

/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

/deep/ .el-tabs__item.is-active {
  color: #0052d9;
}

/deep/ .el-tabs__item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #495770;
  opacity: 1;
}

/deep/ .el-tabs__active-bar {
  width: 64px;
  height: 4px;
  background: #0052d9;
  opacity: 1;
}

.main_five {
  width: 100%;
  height: 222px;
  margin-top: 54px;
  padding: 61px 120px;
  background: url("../../../assets/image/home/bg_five.png");
  background-size: 100% 100%;

  .title {
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #ffffff;
    opacity: 1;
  }

  .btn_line {
    margin-top: 60px;
    display: flex;

    .buy {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 146px;
      height: 48px;
      background: #0066ff;
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }

    .other {
      margin-left: 60px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 146px;
      height: 48px;
      border: 1px solid #ffffff;
      opacity: 1;
      background: transparent;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.about_us {
  position: fixed;
  bottom: 80px;
  right: 40px;
  z-index: 9999;

  .right_icon:hover {
    background: #0066ff;
  }

  .right_icon {
    cursor: pointer;
    background: white;
    width: 64px;
    height: 64px;
    box-shadow: 0px 3px 6px rgba(52, 103, 189, 0.22);
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 36px;
      height: 36px;
    }
  }

  @keyframes slide-down {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  }

  @-webkit-keyframes slide-down {
    0% {
      -webkit-transform: scaleY(0);
    }
    100% {
      -webkit-transform: scaleY(1);
    }
  }

  .contact_lock_1 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 377px;
    right: 107px;
    width: 0;
    height: 64px;
    background: #0066ff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
    /*transition: width .1s;*/

    div {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;

      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }

  .contact_lock_2 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 249px;
    right: 107px;
    width: 0;
    height: 0;
    background: #0066ff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
    /*transition: width .1s, height .2s;*/

    div {
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }

    .QR {
      margin-top: 8px;
      width: 76px;
      height: 76px;
    }
  }

  .contact_lock_3 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 249px;
    right: 107px;
    width: 0;
    height: 64px;
    background: #0066ff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
    /*transition: width .1s;*/

    div {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .contact_lock_4 {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 185px;
    right: 107px;
    width: 0;
    height: 64px;
    background: #0066ff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
    /*transition: width .1s;*/

    div {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .slide-left_lock2 {
    background: #0066ff;
    width: 134px;
    height: 128px;
    /*transition: width .2s, height .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .slide-left_lock {
    background: #0066ff;
    width: 216px;
    /*transition: width .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .slide-left_lock3 {
    background: #0066ff;
    width: 110px;
    /*transition: width .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .slide-left_lock4 {
    background: #0066ff;
    width: 110px;
    /*transition: width .2s;*/
    /*animation: slide-down 0.1s ease-in;*/
    /*-webkit-animation: slide-down 0.1s ease-in;*/
  }

  .goTop {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 42px;
    width: 64px;
    height: 64px;
    background: #0066ff;
    box-shadow: 0px 3px 6px rgba(68, 120, 208, 0.22);
    opacity: 1;

    img {
      width: 36px;
      height: 36px;
    }
  }
}
</style>
